import { Action, ReducerState, ActionType } from "../types/reducer";

const initState = {
  showBestOdds: false,
  activeBookmaker: "bestodds",
  activeBookmakerName: "Best Odds",
  activeOddsFormat: "american", // Set american by default incase we get no odds format coming back from origin?
  bestOdds: {
    odds: "",
    oddsAmerican: "",
    oddsDecimal: 0,
  },
};

const app = (state = initState, action: Action): ReducerState => {
  switch (action.type) {
    case ActionType.BESTODDS:
      return Object.assign({}, state, {
        showBestOdds: action.payload,
      });
    case ActionType.ACTIVE_BOOKMAKER:
      return Object.assign({}, state, {
        activeBookmaker: action.payload,
      });
    case ActionType.ACTIVE_BOOKMAKER_NAME:
      return Object.assign({}, state, {
        activeBookmakerName: action.payload,
      });
    case ActionType.ACTIVE_ODDS_FORMAT:
      return Object.assign({}, state, {
        activeOddsFormat: action.payload,
      });
    case ActionType.BEST_ODDS:
      return Object.assign({}, state, {
        bestOdds: action.payload,
      });

    default:
      return state;
  }
};

export default app;
